// phone.js

// Persian (U+06F0..U+06F9) and Arabic-Indic (U+0660..U+0669) digits, plus the
// Arabic decimal separator some keyboards emit alongside them.
const DIGIT_MAP = {
  "۰": "0", "۱": "1", "۲": "2", "۳": "3", "۴": "4",
  "۵": "5", "۶": "6", "۷": "7", "۸": "8", "۹": "9",
  "٠": "0", "١": "1", "٢": "2", "٣": "3", "٤": "4",
  "٥": "5", "٦": "6", "٧": "7", "٨": "8", "٩": "9",
  "٫": "", "،": "",
};

export const IRANIAN_MOBILE_LENGTH = 11;
export const IRANIAN_MOBILE_REGEX = /^09\d{9}$/;

// Convert Persian/Arabic-Indic digits to Latin so a number typed on a Persian
// keyboard is not silently emptied by a later /\D/ strip.
export const toLatinDigits = (value) =>
  String(value ?? "").replace(/[۰-۹٠-٩٫،]/g, (char) => DIGIT_MAP[char] ?? char);

/**
 * Sanitize a keystroke/paste into something that could still become an Iranian
 * mobile, without ever rejecting input mid-edit:
 *  - Latin digits only (Persian digits are converted, not deleted);
 *  - international prefixes the user actually types — `+98`, `98`, `0098` — are
 *    rewritten to the leading 0, so "+98 912 345 6789" lands as 09123456789;
 *  - a bare 10-digit number starting with 9 (the convention OTPLoginUI uses)
 *    gets its leading 0 restored once it is complete;
 *  - hard-capped at 11 characters so the field can never overflow.
 * Returns "" when the value cannot be part of a valid number.
 */
export const normalizeMobileInput = (raw) => {
  let digits = toLatinDigits(raw).replace(/\D/g, "");

  if (digits.startsWith("0098")) {
    digits = `0${digits.slice(4)}`;
  } else if (digits.startsWith("98")) {
    digits = `0${digits.slice(2)}`;
  } else if (
    digits.length === 10 &&
    digits.startsWith("9")
  ) {
    digits = `0${digits}`;
  }

  return digits.slice(0, IRANIAN_MOBILE_LENGTH);
};

export const isValidIranianMobile = (value) =>
  IRANIAN_MOBILE_REGEX.test(normalizeMobileInput(value));

// Partially typed input should not be flagged as an error while the user is
// still mid-edit, so only a full-length value gets judged.
export const isCompleteMobile = (value) =>
  normalizeMobileInput(value).length === IRANIAN_MOBILE_LENGTH;

export const INVALID_MOBILE_MESSAGE = "شماره همراه وارد شده معتبر نیست (مثال: 09123456789).";
export const REQUIRED_MOBILE_MESSAGE = "لطفا شماره همراه تحویل‌گیرنده را وارد کنید.";